// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CheckoutForm.css
   Visual improvements for Secure Checkout form
   - visual plan cards for quick selection
   - clear form layout and focus/hover states
   - responsive adjustments for mobile
*/
.checkout-form {
  max-width: 760px;
  margin: 0 auto;
  padding: 18px;
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(6,8,15,0.02));
  border-radius: 12px;
  border: 1px solid rgba(148,163,184,0.06);
  box-shadow: 0 10px 30px rgba(2,6,23,0.45);
  color: var(--portal-text, #e2e8f0);
}

.checkout-form h3 {
  margin: 0 0 12px;
  font-size: 20px;
  color: var(--portal-text);
}

.checkout-form__plans {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}

.checkout-plan-card {
  padding: 12px;
  border-radius: 10px;
  background: rgba(15,23,42,0.55);
  border: 1px solid rgba(148,163,184,0.06);
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.checkout-plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(124,58,237,0.12);
  border-color: rgba(124,58,237,0.12);
}

.checkout-plan-card.selected {
  background: linear-gradient(135deg, rgba(124,58,237,0.12), rgba(34,211,238,0.08));
  border-color: rgba(34,211,238,0.22);
  box-shadow: 0 18px 40px rgba(34,211,238,0.12);
  transform: translateY(-6px) scale(1.02);
}

.checkout-plan-card .label { font-weight: 700; font-size: 15px; }
.checkout-plan-card .price { font-weight: 900; color: #cdeffd; font-size: 18px; }
.checkout-plan-card .desc { color: rgba(226,232,240,0.8); font-size: 13px; }

.checkout-form__form {
  display: grid;
  gap: 10px;
}

.checkout-form__select,
.checkout-form__input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgba(148,163,184,0.08);
  background: rgba(6,8,15,0.6);
  color: var(--portal-text);
  font-size: 14px;
}

.checkout-form__select:focus,
.checkout-form__input:focus,
.checkout-plan-card:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(124,58,237,0.12);
  border-color: rgba(124,58,237,0.2);
}

.checkout-form__contract {
  display: flex;
  gap: 10px;
  align-items: center;
}

.checkout-form__submit {
  padding: 12px 18px;
  border-radius: 10px;
  background: linear-gradient(90deg,#7c3aed,#22d3ee);
  color: #fff;
  border: none;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(124,58,237,0.16);
}

.checkout-form__submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; box-shadow: none; }

.checkout-form__error {
  margin-top: 12px;
  color: #ffd6d6;
  background: rgba(255, 0, 0, 0.04);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid rgba(255,0,0,0.06);
}

.checkout-form__result {
  margin-top: 12px;
  background: rgba(250,250,250,0.95);
  color: #0b1220;
  padding: 12px;
  border-radius: 8px;
  max-height: 360px;
  overflow: auto;
}

@media (max-width: 520px) {
  .checkout-form { padding: 12px; }
  .checkout-form__plans { grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); }
}
`, "",{"version":3,"sources":["webpack://./src/components/CheckoutForm.css"],"names":[],"mappings":"AAAA;;;;;CAKC;AACD;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8EAA8E;EAC9E,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,wCAAwC;EACxC,eAAe;EACf,gFAAgF;EAChF,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,iFAAiF;EACjF,mCAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA,6BAA6B,gBAAgB,EAAE,eAAe,EAAE;AAChE,6BAA6B,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AAChF,4BAA4B,4BAA4B,EAAE,eAAe,EAAE;;AAE3E;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;EAClD,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA,kCAAkC,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEzG;EACE,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB,aAAa,EAAE;EAChC,wBAAwB,2DAA2D,EAAE;AACvF","sourcesContent":["/* CheckoutForm.css\n   Visual improvements for Secure Checkout form\n   - visual plan cards for quick selection\n   - clear form layout and focus/hover states\n   - responsive adjustments for mobile\n*/\n.checkout-form {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 18px;\n  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(6,8,15,0.02));\n  border-radius: 12px;\n  border: 1px solid rgba(148,163,184,0.06);\n  box-shadow: 0 10px 30px rgba(2,6,23,0.45);\n  color: var(--portal-text, #e2e8f0);\n}\n\n.checkout-form h3 {\n  margin: 0 0 12px;\n  font-size: 20px;\n  color: var(--portal-text);\n}\n\n.checkout-form__plans {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.checkout-plan-card {\n  padding: 12px;\n  border-radius: 10px;\n  background: rgba(15,23,42,0.55);\n  border: 1px solid rgba(148,163,184,0.06);\n  cursor: pointer;\n  transition: transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.checkout-plan-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 30px rgba(124,58,237,0.12);\n  border-color: rgba(124,58,237,0.12);\n}\n\n.checkout-plan-card.selected {\n  background: linear-gradient(135deg, rgba(124,58,237,0.12), rgba(34,211,238,0.08));\n  border-color: rgba(34,211,238,0.22);\n  box-shadow: 0 18px 40px rgba(34,211,238,0.12);\n  transform: translateY(-6px) scale(1.02);\n}\n\n.checkout-plan-card .label { font-weight: 700; font-size: 15px; }\n.checkout-plan-card .price { font-weight: 900; color: #cdeffd; font-size: 18px; }\n.checkout-plan-card .desc { color: rgba(226,232,240,0.8); font-size: 13px; }\n\n.checkout-form__form {\n  display: grid;\n  gap: 10px;\n}\n\n.checkout-form__select,\n.checkout-form__input {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(148,163,184,0.08);\n  background: rgba(6,8,15,0.6);\n  color: var(--portal-text);\n  font-size: 14px;\n}\n\n.checkout-form__select:focus,\n.checkout-form__input:focus,\n.checkout-plan-card:focus {\n  outline: none;\n  box-shadow: 0 0 0 4px rgba(124,58,237,0.12);\n  border-color: rgba(124,58,237,0.2);\n}\n\n.checkout-form__contract {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.checkout-form__submit {\n  padding: 12px 18px;\n  border-radius: 10px;\n  background: linear-gradient(90deg,#7c3aed,#22d3ee);\n  color: #fff;\n  border: none;\n  font-weight: 800;\n  cursor: pointer;\n  box-shadow: 0 10px 30px rgba(124,58,237,0.16);\n}\n\n.checkout-form__submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; box-shadow: none; }\n\n.checkout-form__error {\n  margin-top: 12px;\n  color: #ffd6d6;\n  background: rgba(255, 0, 0, 0.04);\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(255,0,0,0.06);\n}\n\n.checkout-form__result {\n  margin-top: 12px;\n  background: rgba(250,250,250,0.95);\n  color: #0b1220;\n  padding: 12px;\n  border-radius: 8px;\n  max-height: 360px;\n  overflow: auto;\n}\n\n@media (max-width: 520px) {\n  .checkout-form { padding: 12px; }\n  .checkout-form__plans { grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
